import { generatePath } from "react-router-dom";

// utility function to construct a full path from a slug -- this is usefull when building links to other pages!
// example: getFullPath(slugs.paymentMethods, { accountId: 123 }) => "/billing/payment-methods/123"
// Note this use to be more complicated, but now we can just use the react-router-dom generatePath function + the basename config in the router
// keeping this function for convenience
export const getFullPath = (path: string, params?: any) =>
  generatePath(path, params);
